import React, {useEffect, useState} from "react";
import DataTable from "../DRM/components/DataTable";
import {useDispatch, useSelector} from "react-redux";

import CheckIcon from "../DRM/assets/images/check.svg";
import {setLoading} from "../../redux/actions/DRM_user.action";
import {displayConfirmation, displayLog} from "../DRM/common/common";
import Createactivitycode from "../DRM/createActivityCode/createactivitycode";
import Editactivitycode from "../DRM/EditActivityCode/editactivitycode";
import {Box, Button, Typography} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import Tooltip from "@mui/material/Tooltip";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {axios_tenant} from "../../../axios";

const ActivityCodeManager = (props) => {
	const [pairCode, setPairCode] = useState("");
	const [activityCode, setActivityCode] = useState("");
	const [activityName, setActivityName] = useState("");
	const [id, setId] = useState("");
	const [show, setShow] = useState(false);
	const [show1, setShow1] = useState(false);

	const handleShow = () => setShow(true);

	const dispatch = useDispatch();

	const loading = useSelector((state) => state.userStore.loading);
	let [selectedRows ] = useState([]);

	const [tableData, setTableData] = useState([]);

	useEffect(() => {
		activityCodeResults();
	}, []);

	const activityCodeResults = async () => {
		dispatch(setLoading(true));
		let response = await axios_tenant.get("/drm/fetchActivityCode").then((res) => res.data);
		await response.data.activity_code.forEach((row, index) => { row.serialnumber = index + 1; });
		if (response?.success) {
			setTableData(response.data.activity_code);
		}

		dispatch(setLoading(false));
	};

	const deleteUser = async (id) => {
		let html = `
					<span>Are you sure you want to delete this Code?</span>
					</span>
					<br /> 
					<br /> 
				`;

		let confirm = await displayConfirmation(html, true);

		if(confirm.isConfirmed){
			let req = {
				id: id,
			}
			let response = await axios_tenant.post("/drm/deleteActivityCode", req).then((res) => res.data);
			if (response?.status == 200) {
				displayLog("Activity Code Deleted.","success");
			}
			activityCodeResults();
		}
		
	}

	const columns = [
		{
			field: "serialnumber",
			headerName: "S.N.",
			flex: 0.7,
			// selector: (row, index) =>(index + 1),
			// selector: (row) => row.serialnumber,
			// sortable: true,
			// width: "100px",
		},
		{
			field: "pair_code",
			headerName: "PAIR Code",
			flex: 1,
			// selector: (row) => row.pair_code,
			// sortable: true,
			// width: "250px",
		},
		{
			field: "activity_code", 
			headerName: "Activity Code",
			flex: 1,
			// selector: (row) => row.activity_code,
			// sortable: true,
			// width: "250px",
		},
		{
			field: "activity_name",
			headerName: "Activity Name",
			flex: 3,
			renderCell: ({row}) => <span title={row.activity_name}>{row.activity_name}</span>,
			// selector: (row) => row.activity_name,
			// sortable: true,
			// width: "450px",
		},
		{
			field: "status",
			headerName: "Action",
			flex: 1,
			renderCell: ({row}) => {
				return (
					<span>
						{row.status =="active"?
						(
							<Tooltip title="Activate">
								<IconButton aria-label="Activate" disabled={selectedRows && selectedRows.length > 1} onClick={() => handleAction2(true, row)}>
									<img src={CheckIcon} alt="" className="last-column-action-small pointer" />								
								</IconButton>
							</Tooltip>
						):(
							<Tooltip title="Delete">
								<IconButton aria-label="delete" disabled={selectedRows && selectedRows.length > 1} onClick={() => handleAction2(true, row)} >
									<DeleteOutlineIcon/>
								</IconButton>
							</Tooltip>
						)
						}
						<Tooltip title="Edit">
							<IconButton onClick={() => handleAction2(false, row)}>
								<EditIcon />
							</IconButton >
						</Tooltip>
					</span>
					
				)
			},
			// width: "150px"
		}
	];

	const handleAction2 = async (action, row) => {
		if (action) {
			deleteUser(row.id);
		}
		else {
			setActivityCode(row.activity_code || "");
			setActivityName(row.activity_name);
			setId(row.id);
			setPairCode(row.pair_code);
			setShow1(true)
		}
	};

	return (
		<div>
		{localStorage.getItem("TENANT_ROLE")=="admin"?
		(
			<div className="">
				<Box mb={2} sx={{display: 'flex', justifyContent: 'space-between' }}>
					<Typography variant="h2" component="h2">
						Manage Activity Codes
					</Typography>
					<Button variant="contained" onClick={handleShow}>
							Create Activity Code
					</Button>
				</Box>

						<div className="mt-3">
							<DataTable columns={columns}
								showToolbar={false}
								data={tableData} loading={loading} noDataComponent={loading ? " Fetching data... " : "No records"} />
						</div>
						<Createactivitycode onClose={() => setShow(false)} show={show} onCall={() => { activityCodeResults(); }} />
						<Editactivitycode onClose={() => setShow1(false)} id={id} pair_code={pairCode} activity_code={activityCode} activity_name={activityName} show={show1} onCall={() => { activityCodeResults(); }} />
					</div>
				)
				:
				(
					<div>
						<p>Sorry, you are not allowed to view this page.</p>
					</div>
				)
			}
		</div>
	);
};

export default ActivityCodeManager;